(function () {
  'use strict';

  // Keeps the selected option value shown beside the option name
  // ("Inkpad Color  Black") in sync when a swatch is picked.
  document.addEventListener('change', function (evt) {
    var input = evt.target;
    if (!input || !input.classList || !input.classList.contains('v2-pdp__option-input')) return;

    var option = input.closest('.v2-pdp__option');
    if (!option) return;

    var selected = option.querySelector('[data-option-selected]');
    if (selected) selected.textContent = input.value;
  });

  // Resolves the picked swatch(es) to a real variant and applies it to the
  // page. Add to cart, Buy it now and the sticky bar all read the hidden
  // form field name="id", so it MUST follow the selection — nothing else in
  // this theme writes to it for this custom buy box.
  document.querySelectorAll('[data-section-type="product"]').forEach(function (root) {
    var form = root.querySelector('form[data-product-form]');
    var sectionId = root.getAttribute('data-section-id');
    var jsonEl = document.getElementById('ProductJson-' + sectionId);
    var idField = form ? form.querySelector('[name="id"]') : null;
    var optionInputs = Array.prototype.slice.call(
      root.querySelectorAll('input[type="radio"][data-index]')
    );
    if (!form || !jsonEl || !idField || !optionInputs.length) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var addBtn = form.querySelector('[data-add-to-cart]');
    var addBtnText = addBtn ? addBtn.querySelector('[data-add-to-cart-text]') : null;
    var buyNowBtn = form.querySelector('[data-buy-now-button]');
    var rail = root.querySelector('[data-zoom-trigger]');
    var latestRequest = 0;

    function selectedVariant() {
      var values = [];
      optionInputs.forEach(function (input) {
        if (!input.checked) return;
        var position = parseInt(input.getAttribute('data-index').replace('option', ''), 10) - 1;
        values[position] = input.value;
      });
      return product.variants.find(function (variant) {
        return values.every(function (val, i) {
          return val == null || variant.options[i] === val;
        });
      });
    }

    function syncUrl(variant) {
      if (root.getAttribute('data-enable-history-state') !== 'true') return;
      if (!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function scrollGalleryTo(variant) {
      var mediaId = variant.featured_media && variant.featured_media.id;
      if (!rail || !mediaId) return;
      var slides = Array.prototype.slice.call(
        root.querySelectorAll('[data-product-single-media-wrapper]')
      );
      var target = sectionId + '-' + mediaId;
      var index = slides.findIndex(function (slide) {
        return slide.getAttribute('data-media-id') === target;
      });
      if (index < 0) return;
      var left = slides[index].getBoundingClientRect().left
        - rail.getBoundingClientRect().left
        + rail.scrollLeft;
      rail.scrollTo({ left: left, behavior: 'smooth' });
    }

    // Price, "on sale" state and the add-to-cart label/availability are
    // rendered by Liquid, so ask the Section Rendering API for this variant
    // and copy over only the pieces that depend on it. Leaves every element
    // that other scripts hold references to (buttons, inputs) untouched.
    function refreshFromServer(variant) {
      var request = ++latestRequest;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      url.searchParams.set('sections', sectionId);

      fetch(url.toString(), { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (request !== latestRequest || !data || !data[sectionId]) return;
          var next = new DOMParser().parseFromString(data[sectionId], 'text/html');

          var priceEl = root.querySelector('[data-price]');
          var nextPrice = next.querySelector('[data-price]');
          if (priceEl && nextPrice) {
            priceEl.className = nextPrice.className;
            priceEl.innerHTML = nextPrice.innerHTML;
          }

          var stickyRow = root.querySelector('.v2-pdp__sticky-price-row');
          var nextStickyRow = next.querySelector('.v2-pdp__sticky-price-row');
          if (stickyRow && nextStickyRow) stickyRow.innerHTML = nextStickyRow.innerHTML;

          var nextAdd = next.querySelector('[data-add-to-cart]');
          if (addBtn && nextAdd) {
            addBtn.setAttribute('aria-disabled', nextAdd.getAttribute('aria-disabled') === 'true' ? 'true' : 'false');
            var nextAddText = nextAdd.querySelector('[data-add-to-cart-text]');
            if (addBtnText && nextAddText) addBtnText.textContent = nextAddText.textContent.trim();
          }
          if (buyNowBtn) buyNowBtn.style.display = next.querySelector('[data-buy-now-button]') ? '' : 'none';
        })
        .catch(function () {});
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var variant = selectedVariant();
        if (!variant) return;

        idField.value = String(variant.id);
        if (addBtn && !variant.available) addBtn.setAttribute('aria-disabled', 'true');

        syncUrl(variant);
        scrollGalleryTo(variant);
        refreshFromServer(variant);
      });
    });
  });
})();
